import styled from '@emotion/styled'
import { VFC } from 'react'

export type CCaptionCardProps = {
    src: string
    caption: string
    furigana?: string
    character: string
    talent?: string
    valet?: string
}

const CaptionCardInner = styled.div`
    background: rgba(255, 255, 0, 0.75);
`

export type CCaptionCardViewProps = {} & CCaptionCardProps

export const CaptionCard: VFC<CCaptionCardViewProps> = ({ src, furigana, character, talent, caption, valet }) => {
    return (
        <CaptionCardInner className="flex flex-col text-center max-w-sm mx-auto">
            <img src={src} alt={character} className="object-cover w-full relative aspect-video" />
            <div className="p-4 flex flex-col h-auto w-full">
                <div className="flex flex-col mt-2 w-full font-semibold text-2xl">
                    {furigana && <p className="text-sm">{furigana}</p>}
                    <p className="flex m-auto text-2xl border-b-4 mt-0 border-c-secondary">{character}</p>
                </div>
                {talent && <p className="text-xl w-full mt-2 leading-none font-semibold">CV : {talent}</p>}
                <p className="mt-4 text-base font-normal text-left">{caption}</p>
                <p className="mt-4 text-base font-normal text-left">{valet}</p>
            </div>
        </CaptionCardInner>
    )
}

export default CaptionCard
